import { RefObject } from 'react';

const isRailStuck = (
  railRef: RefObject<HTMLDivElement>,
  stickyOffset: number
): boolean => {
  const stickyHeader = document
    .querySelector('[data-testid="compressed-sticky-header"]')
    ?.getBoundingClientRect() || {
    top: 0,
  };
  const railY = railRef.current?.getBoundingClientRect() || {
    top: Number.POSITIVE_INFINITY,
  };
  return railY.top - stickyHeader.top <= stickyOffset + 1;
};

export default isRailStuck;
